import { Dispatch } from "redux";
import { toast } from "react-toastify";
import { ErrorInterface } from "../../../common/interfaces/ErrorInterface";
import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import {
    setError,
    setEmailError,
    setFormValues,
    setIsPatchEditEmployeeSuccess,
    setSelectedEmployee,
    setResetEmailState,
} from "../EditEmployeeModalSlice";
import { getResetEmailState } from "./getResetEmailState";

interface HandleCancelEmailChangeProps {
    selectedEmployee: EmployeeInterface;
    dispatch: Dispatch;
    cancelChangeEmail: (params: { id: number }) => {
        unwrap: () => Promise<unknown>;
    };
    refetchEmployeeMe: () => Promise<unknown>;
}

export const handleCancelEmailChange = async (
    props: HandleCancelEmailChangeProps,
): Promise<void> => {
    const { selectedEmployee, dispatch, cancelChangeEmail, refetchEmployeeMe } =
        props;

    if (!selectedEmployee) {
        return;
    }

    try {
        await cancelChangeEmail({
            id: selectedEmployee.id,
        }).unwrap();

        toast.info("E-mail wijziging is geannuleerd");

        // Wait for the refetch to complete before updating the state
        await refetchEmployeeMe();

        const updatedEmployee = {
            ...selectedEmployee,
            pending_email_change: undefined,
        };
        dispatch(setSelectedEmployee(updatedEmployee));
        dispatch(setFormValues(null));
        dispatch(setIsPatchEditEmployeeSuccess(true));
        dispatch(setError(null)); // Clear any existing general error messages
        dispatch(setEmailError(null)); // Clear any existing email-specific error messages
        dispatch(setResetEmailState(getResetEmailState())); // Reset email fields
    } catch (err) {
        const errorData = err as ErrorInterface;
        // Add null check to prevent "Cannot read properties of undefined (reading 'message')" error
        const errorMessage =
            errorData?.data?.message ||
            "Er is een fout opgetreden bij het annuleren van de e-mail wijziging";
        dispatch(setError(errorMessage));
    }
};
